export default "__VITE_ASSET__qLrHaIky__"